import React from 'react';
import DavisPredictions from './DavisPredictions';

function App() {
  return <DavisPredictions />;
}

export default App;
